import React from 'react';
import style from './index.css';

export default class PrintTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            xsxx:this.props.initFormDate,//学生信息
            schoolName:this.props.schoolName,//学校名称
            year:this.props.year,//当前年度
            account:this.props.account,//默认账号
            kzxxInitData: this.props.kzxxInitData,
        };
    }

    render() {
        const { xsxx, schoolName, year } = this.state;
        // 下面是测试数据
        // xsxx.bjmc = '建筑与技术2班';
        // xsxx.xqmc = '金山校区';
        // xsxx.ldmc = '公主楼五楼';
        // xsxx.fjmc = 520;
        // xsxx.cwh = 4;
        // xsxx.sfxmList.push({
        //     sfxmmc: '入学总学费',
        //     ysje: 25000,
        //     ssje: 25000
        // });
        if(xsxx.sfxmList.length === 0) {
            xsxx.sfxmList.push({
                sfxmmc: "",
                ysje: "",
                ssje: ""
            });
        }
        return (
            <div className={style.box}>
                <div>
                    <div style={{textAlign: 'center'}}>
                        <div className={style.title} style={{fontWeight: 'bold'}}>
                            {schoolName}{year}新生入学报到单
                        </div>
                    </div>
                    <div style={{fontSize: 14, marginLeft: 28, color: '#0d0d0d'}}>
                        <span>{xsxx.xm}同学，你好！欢迎来到我校，你的基本信息如下：</span>
                    </div>
                    <div className={style.tableDiv}>
                        <table>
                            <tbody>
                            <tr className={style.tableTitle}>
                                <td colSpan="6" style={{paddingLeft: 10}}>基本信息</td>
                            </tr>
                            <tr className={style.tableItem}>
                                <td>系部</td><td>{xsxx.bmmc}</td>    <td>录取专业</td><td>{xsxx.zymc}</td>  <td>班级名称</td><td>{xsxx.bjmc}</td>
                            </tr>
                            <tr>
                                <td colSpan={"6"} style={{height: 14}}/>
                            </tr>
                            <tr className={style.tableItem}>
                                <td>姓名</td><td>{xsxx.xm}</td>      <td>性别</td><td>{xsxx.xb}</td>      <td>联系电话</td><td>{xsxx.sjhm}</td>
                            </tr>
                            <tr className={style.tableItem}>
                                <td>民族</td><td>{xsxx.mz}</td>      <td>籍贯</td><td>{xsxx.jg}</td>      <td>考生号</td> <td>{xsxx.ksh}</td>
                            </tr>
                            <tr className={style.tableItem}>
                                <td>政治面貌</td><td colSpan={"2"}>{xsxx.zzmm}</td>   <td>身份证号</td>     <td colSpan={"2"}>{xsxx.sfzjh}</td>
                            </tr>
                            <tr className={style.tableItem}>
                                <td>家庭住址</td>  <td colSpan={"5"}>{xsxx.jg}{xsxx.jtdz}</td>
                            </tr>

                            <tr>
                                <td colSpan={"6"} style={{height: 14}}/>
                            </tr>

                            <tr className={style.tableTitle}>
                                <td colSpan="6" style={{paddingLeft: 10}}>宿舍信息</td>
                            </tr>
                            <tr className={style.tableItem}>
                                <td>校区</td><td colSpan={"2"}>{xsxx.xqmc}</td>    <td>楼栋</td><td  colSpan={"2"}>{xsxx.ldmc}</td>
                            </tr>
                            <tr className={style.tableItem}>
                                <td>宿舍编号</td><td  colSpan={"2"}>{xsxx.fjmc}</td>  <td>床位编号</td><td  colSpan={"2"}>{xsxx.cwh}</td>
                            </tr>

                            <tr className={style.tableTitle}>
                                <td colSpan="6" style={{paddingLeft: 10}}>缴费信息</td>
                            </tr>
                            <tr className={style.tableItem}>
                                <td>收费项目</td><td colSpan={"2"}>{xsxx.sfxmList[0].sfxmmc}</td> <td>应缴金额</td><td  colSpan={"2"}>{xsxx.sfxmList[0].ysje}</td>
                            </tr>
                            <tr className={style.tableItem}>
                                <td>已交金额</td><td  colSpan={"2"}>{xsxx.sfxmList[0].ssje}</td>  <td colSpan={"2"}>备注（是否贷款）</td> <td />
                            </tr>

                            <tr>
                                <td colSpan={"6"} style={{height: 14}}/>
                            </tr>

                            <tr style={{height: '62mm', width: '45mm'}}>
                                <td colSpan={"2"} className={style.tableItemPhotoPaste}>
                                    <img className={style.jbxx_icon_bg} src={'api/sm-student/openapi/getStudentPhoto?xsid=' + xsxx.xsid+'&type=10'} alt=""/>
                                </td>
                                <td colSpan={"2"} className={style.tableItemConfirmTd}>经办老师签字确认：</td>
                                <td colSpan={"2"} className={style.tableItemConfirmTd}>学生签字确认：</td>
                            </tr>
                            <tr style={{height: '62mm', width: '45mm'}}>
                                <td colSpan={"2"}  className={style.tableItemPhotoPaste}>粘贴2寸免冠证件照</td>
                                <td colSpan={"2"} className={style.tableItemConfirmTd}>
                                    <div>
                                        新生入学资格复查，确认<br/>
                                        学生本人与录取学生为同<br/>
                                        一个人，并由辅导员签字：
                                    </div>
                                </td>
                                <td colSpan={"2"} className={style.tableItemConfirmTd}>
                                    <div>
                                        新生入学资格复查，由学<br/>
                                        生本人签字并填写学号：
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <div style={{fontSize: 16, marginLeft: 28, color: '#FF0000'}}>
                            <span>注：注册结束后报到单由辅导员统一收齐，并在新生入学资格复查后，交教务处存档。</span>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/yxxc/print/Bdd/fjlyzyxy/FjlyzyxyPrint.js